/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ====================
// Collection circles carousel logic
// ====================
theme.collectionCirclesCarouselUpdate = function(element) {
  var $carousel = $(element);

  function collectionCirclesCarouselInitFull($carousel) {
    $carousel.not(".slick-initialized").slick({
      infinite: false,
      arrows: false,
      dots: false,
      speed: 300,
      lazyLoad: "progressive",
      variableWidth: true,
      swipeToSlide: true,
    });
  }

  $carousel.removeClass("collection-circles-carousel--loading");

  collectionCirclesCarouselInitFull($carousel);
};

theme.collectionCirclesCarouselInit = function(element) {
  theme.collectionCirclesCarouselUpdate(element);

  $(window).on('resize', function updateCollectionCirclesCarouselOnResize() {
    theme.collectionCirclesCarouselUpdate(element);
  });
};

theme.collectionCirclesCarousel = function() {
  var $carousels = $(".js-collection-circles-carousel");

  var collectionCirclesCarouselObserver = generateFireOnViewObserver(theme.collectionCirclesCarouselInit);

  if ($carousels.length > 0) {
    $carousels.each(function() {
      var carousel = this;
      if (collectionCirclesCarouselObserver && !Shopify.designMode) {
        collectionCirclesCarouselObserver.observe(carousel);
      } else {
        theme.collectionCirclesCarouselInit(carousel);
      }
    });
  }
};

/*----------------------------------------------------------------------------- */
theme.collectionCirclesCarousel();
